var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockConnector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9:34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15473 18C6.52294 17.9982 4.95849 17.3492 3.80464 16.1954C2.65079 15.0415 2.00178 13.4771 2 11.8453V8.35754C2 8.19417 2.0649 8.0375 2.18042 7.92198C2.29593 7.80646 2.45261 7.74156 2.61598 7.74156H13.6935C13.8567 7.74156 14.0133 7.80634 14.1287 7.92168C14.2442 8.03702 14.3092 8.19348 14.3095 8.3567V11.8453C14.3075 13.477 13.6584 15.0413 12.5046 16.1951C11.3508 17.3489 9.78645 17.998 8.15473 18ZM8.15473 10.8198C7.9343 10.8197 7.71971 10.8906 7.54277 11.022C7.36582 11.1535 7.23593 11.3385 7.17236 11.5495C7.10879 11.7606 7.11491 11.9865 7.18983 12.1938C7.26474 12.4011 7.40446 12.5788 7.58827 12.7004L7.0646 14.3469H9.30108L8.70273 12.7122C8.89061 12.5934 9.03483 12.4169 9.11367 12.2091C9.19252 12.0013 9.20173 11.7735 9.13991 11.56C9.07809 11.3465 8.94859 11.1589 8.77091 11.0254C8.59323 10.8919 8.37698 10.8197 8.15473 10.8198V10.8198Z",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    className: "transparent",
    d: "M3.52151 8.47653V5.22625C3.52151 5.22625 3.91582 0.958347 8.1773 1.00031C12.1862 1.03136 12.4303 4.41736 12.4303 4.41736",
    stroke: "#353841",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9:34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.426,
    height: 17.883,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockConnector);
export default __webpack_public_path__ + "static/media/unlock_connector.6a4538019a39adf0ddfbd854ec885539.svg";
export { ForwardRef as ReactComponent };